import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core'
import { ICanActivateOverlays } from '../../models/CanActivate'

@Component({
  selector: 'first-overlays',
  templateUrl: './first-overlays.component.html',
  styleUrls: ['./first-overlays.component.scss'],
})
export class FirstOverlaysComponent implements OnInit {

  @Input() otherParameters: ICanActivateOverlays = null

  @Output() agreed = new EventEmitter<boolean>()

  constructor() { }

  ngOnInit() {}

  public onDismiss() {
    this.agreed.emit(true)
  }

}
